module.exports = __webpack_public_path__ + "media/images/icon-life-0b73d3bbb18df49fee2cb8fd51dee72a.png";